<template lang="html">
  <div>
    <pulse-loader :loading="loading" />

    <div v-if="!loading">
      <div class="vx-row">
        <div class="vx-col  hidden lg:w-1/6 lg:block mb-base "></div>
        <div class="vx-col w-1/6  mb-base">
          <vx-tooltip
            text="Als je een slimme meter hebt en je verbruik in wilt zien, dan kan je dit hier aan zetten"
          >
            Verbruiksinzicht:
            <vs-switch
              color="success"
              v-model="continuous"
              v-on:change="setSmartMetering"
            >
              <span slot="on">Aan</span>
              <span slot="off">Uit</span>
            </vs-switch>
          </vx-tooltip>
        </div>
        <div
          class="vx-col lg:w-1/3 w-full mb-base"
          v-if="customerStatus.has_smart_meter_points"
        >
          <vx-card>
            <h3>Getoonde Periode:</h3>
            {{ usageSettings | date }}
          </vx-card>
        </div>
      </div>

      <div
        class="vx-row"
        v-if="customerStatus.has_smart_meter_points && !continuous"
      >
        <div class="vx-col  hidden lg:w-1/6 lg:block mb-base "></div>

        <div class="vx-col lg:w-1/2 mb-base">
          <vs-alert
            :title="$t('data_still_present')"
            active="true"
            color="warning"
          >
            Ondanks dat je je constante bemetering hebt uitgezet, hebben wij nog
            wel steeds alle verzamelde historische data. Mocht je je verbruik
            willen verwijderen vanuit privacy-overwegingen, dan kan je een mail
            sturen naar service@naked-energy.nl.
          </vs-alert>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col lg:w-1/6 "></div>
        <div
          class="vx-col lg:w-5/6 w-full mb-base"
          v-if="!customerStatus.has_smart_meter_points"
        >
          <vs-alert title="Geen data aanwezig" active="true" color="warning">
            Je hebt nog geen verbruiksgeschiedenis. Als je je verbruiksinzicht
            hebt aangezet, dan duurt dit minstens een dag voordat het verbruik
            zichtbaar is. Als het langer duurt, neem dan contact met ons op via
            de chat of service@naked-energy.nl
          </vs-alert>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col xl:w-1/6 lg:w-full lg:mr-auto lg:ml-auto mb-base ">
          <usage-settings />
        </div>
        <div class="vx-col xl:w-5/6 w-full">
          <div class="vx-row">
            <usage-stat
              v-for="connection in connections"
              v-bind:key="connection.id"
              v-bind:connection-id="connection.id"
              v-bind:icon="connection.type"
            />
          </div>
          <div class="vx-row">
            <div
              class="vx-col  lg:w-1/2  w-full mb-base"
              v-for="connection in connections"
              v-bind:key="connection.id"
            >
              <vx-card
                v-bind:title="
                  connection.type == 'Electricity' ? 'Elektriciteit' : 'Gas'
                "
              >
                <usage-graph v-bind:connection-id="connection.id" />
              </vx-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import UsageGraph from "@/components/usage/UsageGraph.vue";
import UsageSettings from "@/components/usage/UsageSettings.vue";
import UsageStat from "@/components/usage/UsageStat.vue";

import axios from "../axios";
import { mapState } from "vuex";
import moment from "moment";
export default {
  components: {
    UsageGraph,
    UsageSettings,
    UsageStat,
    PulseLoader
  },
  computed: mapState(["customerStatus", "usageSettings"]),
  methods: {
    async getSmartMeteringEnabled() {
      let response = await axios().get(
        `api/energyconsumption/${this.id}/smart_metering`
      );
      this.continuous = response.data;
    },
    async setSmartMetering() {
      await axios().post(
        `api/energyconsumption/${this.id}/smart_metering`,
        this.continuous
      );
      await this.getSmartMeteringEnabled();
    },

    async getConnections() {
      let response = await axios().get(
        `api/contracts/${this.id}/connections?meterTypeSearch=Smart&hasSmartMeterPoints=true`
      );
      this.connections = response.data;
    },
    async getMinMaxDate() {
      if (!this.customerStatus.has_smart_meter_points) {
        this.loading = false;
        return;
      }
      if (
        this.$store.state.usageSettings.fromDate == null ||
        this.$store.state.usageSettings.toDate == null
      ) {
        let response = await axios().get(
          `api/energyconsumption/${this.id}/minmaxdate`
        );

        let fromDate = moment().format("YYYY-MM-DD");
        if (response.data != null) {
          let toDate = response.data[1];
          fromDate = moment(toDate).format("YYYY-MM-DD");
          this.$store.commit("setMinMaxDate", response.data);
        }

        this.$store.commit("updateFromDate", fromDate);
        this.$store.commit("updateToDate", fromDate);
        this.loading = false;
      } else {
        this.loading = false;
      }
    }
  },

  async created() {
    await this.getSmartMeteringEnabled();
    await this.getConnections();
    await this.getMinMaxDate();
  },
  filters: {
    date: function(usageSettings) {
      let fromDate = moment(usageSettings.fromDate);
      let toDate = moment(usageSettings.toDate);

      let calendarSettings = {
        sameDay: "[Vandaag]",
        lastDay: "[Gisteren]",
        lastWeek: "dddd LL",
        sameElse: "dddd LL"
      };

      let fromDateCalendar = fromDate
        .locale("nl")
        .calendar(null, calendarSettings);

      let toDateCalendar = toDate.locale("nl").calendar(null, calendarSettings);

      return fromDate.isSame(toDate)
        ? fromDateCalendar
        : `${fromDateCalendar} - ${toDateCalendar}`;
    }
  },
  props: ["id"],
  data() {
    return { continuous: false, connections: [], loading: true, error: null };
  }
};
</script>
